import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';
import * as mutationTypes from './mutation-types';
import { getList } from '../api';

// type cachePathType = ['contribute'];
interface IState {
  articleList: any[];
  activeArticleIndex: number;
  passedWelcome: boolean;
}

const state: IState = {
  articleList: [],
  activeArticleIndex: 0,
  passedWelcome: false,
};
const mutations: MutationTree<IState> = {
  [mutationTypes.GET_ARTICLE_LIST](state, data) {
    state.articleList = data;
  },
  [mutationTypes.SET_ACTIVE_ARTICLE_INDEX](state, data: number) {
    state.activeArticleIndex = data;
  },
  [mutationTypes.PASS_WELCOME](state) {
    state.passedWelcome = true;
  },
};

const actions: ActionTree<IState, any> = {
  async getArticlesAsync({ commit, state }) {
    const ret = await getList({ search: '', schoolType: '' });
    commit(mutationTypes.GET_ARTICLE_LIST, ret.data);
  },
};

const getters: GetterTree<IState, any> = {
  activeArticle(state) {
    return state.articleList[state.activeArticleIndex];
  },
};

const CDWMHJZS20201231: Module<IState, any> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default CDWMHJZS20201231;
